<template>
  <v-form ref="form">
    <v-card-text>
      <v-combobox label="Location Name" :rules="[rules.required]" v-model="locationName" :items="formObject.dataTypes" item-text="name" item-value="name" hide-details :return-object="false">
        <template v-slot:item="{ item }">
          <v-list-tile-content>
            <v-list-tile-title v-html="item.name" />
            <v-list-tile-sub-title v-html="item.type" />
          </v-list-tile-content>
        </template>
      </v-combobox>
    </v-card-text>
    <!-- <v-divider /> -->
    <!-- <SelectDataSources class="mb-3" v-model="formObject.dataTypes" :mfId="formObject.Id" :displayName="locationName" /> -->
    <!-- <v-divider /> -->
  </v-form>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const navigation = createNamespacedHelpers('navigation')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import SelectDataSources from './SelectDataSources'

  export default {
    components: {
      SelectDataSources,
    },
    data: () => ({
      formObject: {
        primaryName: null,
        dataTypes: [],
        MonitoringFeatureId: null,
        monitoringFeature: {},
      },
      selectedLocation: null,
      locationName: null,
      rules: {
        required: (v) => !!v || 'Required',
      },
    }),
    computed: {
      ...navigation.mapGetters(['searchableLocationItems']),
      ...monitoringFeatures.mapGetters(['monitoringFeaturesIndex']),
    },
    methods: {
      validate() {
        return this.$refs.form.validate()
      },
      setForm(formObject) {
        this.formObject = formObject
        this.locationName = formObject.primaryName
      },
      getForm() {
        let dataTypes = this.formObject.dataTypes.map(dt => ({
          sourceId: dt.station.Id,
          sourceType: dt.sourceType,
          monitoringFeatureId: this.formObject.id,
        }))

        let result = {
          dataTypes,
          Id: this.formObject.id,
          DisplayName: this.locationName,
        }

        return result
      },
    },
  }
</script>